const defaultState = {
  show: false,
};

const loadingComponentReducer = (state = defaultState, action) => {
    
  switch (action.type) {
    case "UPDATE_LOADING":
      return {
        ...state,
        ...action.loading,
      };
    default:
      return { ...state };
  }
};

export default loadingComponentReducer;
